export const languages = [
    { code: "es", name: "spanish", id: 1 },
    { code: "pt", name: "portuguese", id: 2 },
    { code: "en", name: "english", id: 3 }
]